import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import $ from 'jquery';
import OutsideNotifier from '../../OutsideNotifier';
import config from './../../config';
import common from './../../common';
import { resetTeam, toggleProgressAnimation, triggerHandleFixturePopup } from './../../actions/FormationActions';
import trackEventsObj from './../../constants/new-pageTrackEvents'
import {
    resetAllFilters,
} from './../../actions/FilterActions';

class ProgressBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            elemWidth: 0,
            isMoreOpen: false
        };
    }

    componentWillUnmount() {
        this.setState({
            isMoreOpen: false,
        });
    }

    addAnimationClass = () => {
        this.setState({ elemWidth: $('.si-prgs-percentage').width() });
    };
    toggleMoreIcon = () => {
        this.setState(prevState => ({
            isMoreOpen: !prevState.isMoreOpen,
        }));
    };
    onResetTap = () => {
        // this.props.resetAllFilters();
        const oldFormationId = this.props.defaultFormationIndex;
        this.props.resetTeam(this.props.constraints, undefined, oldFormationId);
    };
    onUpcomingFixturesTap = () => {
        this.props.triggerHandleFixturePopup(true);
    };
    onRulesTap = () => {
        common.pageViewTracking(config.RULES_URL, trackEventsObj["rules"]);
        return window.open(config.RULES_URL);
    };
    onHelpTap = () => {
        common.pageViewTracking(config.HELP_URL, trackEventsObj["help"]);
        return window.open(config.HELP_URL);
    };
    triggerPrev = () => {
        this.props.history.goBack();
    };

    componentDidUpdate() {

    }

    componentWillUpdate() {
    }

    componentWillReceiveProps(nextProps) {
        let percentage_next = 0;
        {
            const { playerCount, captainID, badgeID, teamName, clubID } = nextProps;
            const progress_next = playerCount + +(captainID !== null) + +(badgeID !== null) + +(teamName !== null) + +(clubID !== null);
            percentage_next = Math.round((progress_next / config.MAX_COUNT_FOR_PERCENTAGE) * 100);
        }
        const { playerCount, captainID, badgeID, teamName, clubID } = this.props;
        const progress = playerCount + +(captainID !== null) + +(badgeID !== null) + +(teamName !== null) + +(clubID !== null);
        const percentage = Math.round((progress / config.MAX_COUNT_FOR_PERCENTAGE) * 100);
        if (percentage_next !== percentage) {
            this.addAnimationClass();
            this.props.toggleProgressAnimation();
        }
    }

    render() {
        const location = this.props.location;
        const { playerCount, captainID, badgeID, teamName, clubID, constraints } = this.props;
        const { IsFixtureUpdated } = constraints;
        const isFixtureUpdated = (IsFixtureUpdated === 1 || IsFixtureUpdated === "1");
        const isMoreOpen = this.state.isMoreOpen;
        if (typeof playerCount === 'undefined') return null;
        const progress = playerCount + +(captainID !== null) + +(badgeID !== null) + +(teamName !== null) + +(clubID !== null);
        const percentage = Math.round((progress / config.MAX_COUNT_FOR_PERCENTAGE) * 100);
        const styleObj = {
            left: `calc(${percentage}% - ${(this.state.elemWidth / 2) ? (this.state.elemWidth / 2) : 15}px)`,
            opacity: this.props.willAnimate ? '1' : '0'
        };
        const menuClasses = common.makeClasses({
            'si-more-btn': true,
            'si-cols': true,
            'si-active': isMoreOpen
        });
        const resetClass = common.makeClasses({
            'si-disabled': playerCount === 0
        });
        const upcomingFixturesClass = common.makeClasses({
            'si-disabled': !isFixtureUpdated
        });
        const pageStep = getStep(location.pathname);
        const removeOverflow = (pageStep === 1 || pageStep === 2 || pageStep === 3 || pageStep === 4 || pageStep === 5);
        const showRules = false;
        return <div className="si-top-bar si-flexBox">
            <div className="si-back-btn si-cols">
                { pageStep !== 0 ? <i className="icon-ucl-back_arrow" onClick={ () => this.triggerPrev() } /> : null }
            </div>
            <div className="si-prgs-wrap si-cols">
                <div className="si-prgs-bar-outer">
                    <div className="si-prgs-bar-inner" style={ { width: percentage + '%' } } />
                </div>
                <div className={ "si-prgs-percentage" }
                    style={ styleObj }>{ `${percentage}%` }</div>
            </div>
            { !removeOverflow ? <div className={ menuClasses } onClick={ () => this.toggleMoreIcon() }>
                <i className="icon-ucl-more" />
                { isMoreOpen ? <OutsideNotifier handler={ this.toggleMoreIcon.bind(this) }>
                    <div className="si-more-menu">
                        { pageStep === 0 ? <span className={ resetClass }
                            onClick={ () => this.onResetTap() }>{ this.props.trans.reset }</span> : null }
                        { (pageStep === 0 && isFixtureUpdated) && common.isMobile() ? <span className={ upcomingFixturesClass }
                            onClick={ () => this.onUpcomingFixturesTap() }>{ this.props.trans.upcomingFixtures }</span> : null }
                        { showRules ?
                            <span onClick={ () => this.onRulesTap() }>{ this.props.trans['menu_rules'] }</span> : null }
                        {/* <span onClick={ () => this.onHelpTap() }>{ this.props.trans['help_n_feedback'] }</span> */}
                    </div>
                </OutsideNotifier> : null }
            </div> : null }
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        playerCount: state.formationData.teamData.playerCount,
        captainID: state.formationData.teamData.captainID,
        badgeID: state.formationData.teamData.badgeID,
        teamName: state.formationData.teamData.teamName,
        clubID: state.formationData.teamData.clubID,
        defaultFormationIndex: state.formationData.defaultFormationIndex,
        willAnimate: state.formationData.willAnimate,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetTeam: (constraints, oldFormationId, newFormationId) => dispatch(resetTeam(constraints, oldFormationId, newFormationId)),
        resetAllFilters: () => dispatch(resetAllFilters()),
        toggleProgressAnimation: () => dispatch(toggleProgressAnimation()),
        triggerHandleFixturePopup: (isFixturePopupVisible) => dispatch(triggerHandleFixturePopup(isFixturePopupVisible))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProgressBar));


// WEBPACK FOOTER //
// ./src/components/onboarding/ProgressBar.js